import { Box, Button, Flex, Heading, Img, Text } from "@chakra-ui/react";
import React from "react";
import Typewriter from "typewriter-effect";
import styles from "../styles/Hero.module.css";

const About = () => {
  return (
    <Box id="about" pos={"relative"} zIndex={2} h="auto" border="1px solid white" p="50px 0px">
      <Box display={"inline-block"}>
        <Heading>About Me</Heading>
        <Box
          h="6px"
          w="100%"
          mt="10px"
          bg="rgb(34,83,200)"
          borderRadius={"5px"}
        ></Box>
      </Box>

      <Box display={"flex"} flexDir={["column","column","row"]} border="1px solid white" mt="30px" gap="20px" justifyContent={"center"} alignItems="center">
        <Box w={["250px","250px","30%"]} border="1px solid white">
          <Img
            h="350px"
            borderRadius={"10px"}
            alt="profilepicture"
            src="profilepic.jpg"
            
          />
        </Box>
        <Box border="1px solid white" w={["80%","80%","40%"]}>
          <Text align={"left"} fontSize="20px" color="#2253c8" fontWeight={700}>
            <Typewriter
              options={{
                strings: ["Get to know about me!"],
                autoStart: true,
                smooth: true,
                loop: true,
              }}
            />
          </Text>
          <Text align="left" fontSize={"17px"} fontWeight={500} >
            Passionate MERN stack web developer who has worked on serveral
            individual and group project and also worked on his Data Structures
            and Algorithms knowledge.Want's to master the craft of coding such
            that it looks like a artwork and would also like to try different
            fields and languages in computer science to built vast amount of
            knowledge. Right now searching for a organization to use what
            learned and get exposure to real-world problems and to give my best
            for the growth of organization. Likes to work on typing speed and
            would like to type at 150 WPM  or more one day.
          </Text>
          <Flex gap="10px" mt="10px">
          <a 
          href="https://drive.google.com/file/d/1hP8mEK3N_a_Uwxj-or0hx91VipW7I1id/view?usp=sharing" target="_blank"
          ><Button _hover={{bg:"white",color:"#2253c8",border:"1px solid #2253c8"}} h="50px" bg="#2253c8" color="white" >Preview CV</Button></a>

          <a
          href="https://drive.google.com/uc?id=1hP8mEK3N_a_Uwxj-or0hx91VipW7I1id&export=download" 
          ><Button _hover={{bg:"white",color:"#2253c8",border:"1px solid #2253c8"}} h="50px" bg="#2253c8" color="white" >Download CV</Button></a>
          </Flex>
        </Box>
      </Box>
    </Box>
  );
};

export default About;
